import { action, observable, runInAction } from 'mobx'
import { rankingEvent } from '../../services/api'
import { Schema$RankingEvent, Schema$UserRanking } from '@interface/ranking-event'

export class RankingEventStore {
  private api = rankingEvent

  @observable
  currentEvent: Schema$RankingEvent = null

  @observable
  prevEventId: number = null

  @observable
  nextEventId: number = null

  @observable
  rankings: Schema$UserRanking[] = []

  @observable
  totalCount: number = 0

  @observable
  myRanking: Schema$UserRanking = null

  @observable
  isLoadingRankings: boolean = false

  // 랭킹버튼 자동 표시용 전역 플래그 (대기/진행/종료-결과노출 이벤트 존재 여부)
  @observable
  hasRankingButtonEvent: boolean = false

  // 리그필터버튼 자동 표시용 전역 플래그 (진행 중 이벤트 존재 여부)
  @observable
  hasOngoingEvent: boolean = false

  @action
  setRankingButtonFlags(res: { hasRankingButtonEvent?: boolean, hasOngoingEvent?: boolean }): void {
    this.hasRankingButtonEvent = res?.hasRankingButtonEvent ?? false
    this.hasOngoingEvent = res?.hasOngoingEvent ?? false
  }

  @action
  async fetchRankingEvent(eventId?: number): Promise<void> {
    try {
      const result = await this.api.fetchRankingEventInfo({
        eventId,
      })

      runInAction(() => {
        if (result.event) {
          this.currentEvent = result.event
          this.prevEventId = result.navigation.prevEventId
          this.nextEventId = result.navigation.nextEventId
        }
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  async fetchRankingButtonFlags(): Promise<void> {
    try {
      const result = await this.api.fetchRankingButtonFlags()
      runInAction(() => {
        this.setRankingButtonFlags(result)
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  async fetchRankingBoard(eventId: number, offset: number = 0, limit: number = 20): Promise<void> {
    if (this.isLoadingRankings) return

    this.isLoadingRankings = true
    if (offset === 0) {
      this.rankings = []
    }

    try {
      const result = await this.api.fetchRankingBoard({
        eventId,
        offset,
        limit,
      })

      runInAction(() => {
        if (offset === 0) {
          this.rankings = result.rankings
        } else {
          this.rankings = [...this.rankings, ...result.rankings]
        }
        this.totalCount = result.totalCount
      })
    } catch (err) {
      console.error(err)
    } finally {
      runInAction(() => {
        this.isLoadingRankings = false
      })
    }
  }

  @action
  async fetchMyRanking(eventId: number): Promise<void> {
    try {
      const result = await this.api.fetchMyRanking({
        eventId,
        userPromiseId: '',
      })

      runInAction(() => {
        this.myRanking = result.myRanking
      })
    } catch (err) {
      console.error(err)
    }
  }

  @action
  reset(): void {
    this.currentEvent = null
    this.prevEventId = null
    this.nextEventId = null
    this.rankings = []
    this.totalCount = 0
    this.myRanking = null
    this.isLoadingRankings = false
    // hasRankingButtonEvent / hasOngoingEvent 는 전역 표시 플래그로,
    // 팝업/화면 단위 reset 대상이 아니다. (앱 진입점에서 1회 세팅 후 유지)
  }
}

const rankingEventStore = new RankingEventStore()
export default rankingEventStore
